import React from 'react';
import UIFlex from './ui/UIFlex';
import { CircularProgress } from '@mui/material';

interface IWithLoaderProps {
  loading: boolean;
  children: React.ReactElement | null;
}

const WithLoader: React.FC<IWithLoaderProps> = ({ loading, children }) => {
  return loading ? (
    <UIFlex justifyContent={'center'} alignItems={'center'} my={'auto'}>
      <CircularProgress size={80} sx={{ m: 'auto' }} />
    </UIFlex>
  ) : (
    children
  );
};

export default WithLoader;
